import axios from 'axios';

import RestClient from '../../services/RestClient';
import getEndPoint from './apiConstants';
import config from '../../services/config';
import Storage from '../../services/storage';

const getToken = () => {
  try {
    return Storage.getItem('hubToken').access_token
  } catch (e) {
    return null;
  }
};

class HubRestClient extends RestClient {

  static options = {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    mode: 'cors',
  };

  
  static verifyOtp(payload) {
    const { token, ...rest } = payload;
    const otpPayload = {
      otp: rest
      };
    const options = {
      method: 'POST',
      body: JSON.stringify(otpPayload),
      headers: {// hub client token 
        ...this.options.headers, ...token && { Authorization: `Bearer ${token}`},
      }
    }
    return this.request(getEndPoint('hubVerifyOtp'), options);
  }
  
  static async passwordGrantTypeRequest(url, options) {
    const allOptions = { ...this.options, ...options };
    const response = await fetch(url, allOptions);
    await this.checkStatus(response, options);
    return this.responseJson(response);
  }

  static login(payload) {
    const clientId = config.get('clientId');
    const scope = payload.isMFAEnabled ? 'login_via_password' : config.get('loginScope');
    const options = {
      method: 'POST',
      body: JSON.stringify({ scope, username: payload.email, password: payload.password, grant_type: 'password', client_id: clientId }),
      headers: {
        ...this.options.headers,
      }
    }
    return this.passwordGrantTypeRequest(getEndPoint('hubLogin'), options);
  }
  
  static setPassword(payload) {
    const options = {
      method: 'PUT',
      body: JSON.stringify(payload),
      headers: {
        ...this.options.headers,
      }
    }
    return this.request(getEndPoint('hubSetPassword'), options);
  }

  static findOrCreate(payload) {
    const options = {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: { // always use hubclient token for foc call
        ...this.options.headers, Authorization: `Bearer ${getToken()}`
      },
    };
    return this.request(getEndPoint('hubFindOrCreateUrl'), options);
  }
  
  static sendOtp(payload) {
    const { token, ...rest } = payload;
    const otpPayload = {
      otp: rest,
      };
    const options = {
      method: 'POST',
      body: JSON.stringify(otpPayload),
      headers: {// hub client token
        ...this.options.headers, ...token && { Authorization: `Bearer ${token}`},
      }
    }
    return this.request(getEndPoint('hubSendOTP'), options)
  }

  static sendVerifyLink(payload) {
    const { token, ...rest } = payload;
    const linkPayload = {
      verification_link: rest,
    };
    const options = {
      method: 'POST',
      body: JSON.stringify(linkPayload),
      headers: { // full token
        ...this.options.headers, ...token && { Authorization: `Bearer ${token}`},
      }
    }
    return this.request(getEndPoint('hubSendVerificationLink'), options)
  }

  static sendResetLink(payload, token) {
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: '*/*',
      'Authorization': `Bearer ${token}`
    }
    var bodyFormData = new FormData();
    bodyFormData.append('user[identity]',payload);
    return axios({
      method: "POST",
      url: getEndPoint('hubResetLink'),
      data: bodyFormData,
      headers,
    });
  }
}

export default HubRestClient;